module.exports = __webpack_public_path__ + "img/newsBg1.e1a8c8b3.png";